import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import FiisPageLayout from "components/company/v3/layouts/FiisPageLayout";
import { CompanyEventsTabEnum } from "components/company/v3/menu/enums";
import FiisEventsBox from "components/company/v3/realestatefunds/boxes/FiisEventsBox";
import FiiIssuerSeo from "components/company/v3/seo/FiiIssuerSeo";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import useSelfie from "lib/hooks/useSelfie";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { ISecurityCountry } from "types/graphqlTypes";

interface FiisEventsPageProps {
  tickerSymbol: string | null;
}

const FiisEventsPage: NextPage<FiisEventsPageProps> = function FiisEventsPage({ tickerSymbol }) {
  const viewer = useSelfie();
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyEventsTabEnum>(Object.values(CompanyEventsTabEnum)).withDefault(
      CompanyEventsTabEnum.DIVIDENDS,
    ),
  );

  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();
  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <FiisPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Ações" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <FiiIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Dividendos",
              id: "CXcewN",
              description: "Título da página - SEO",
            })}
            description={intl.formatMessage({
              defaultMessage:
                "Histórico completo de rendimentos distribuídos, com valores, data com, data de pagamento e o Dividend Yield (DY) atualizado.",
              id: "bV0IcU",
              description: "Descrição da página de rendimentos de um FII - SEO",
            })}
          />

          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Br}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Dividendos", id: "A7Fc1J" })}
              description={intl.formatMessage({
                defaultMessage:
                  "Confira abaixo a tabela completa e atualizada com todo histórico de dividendos pagos, declarados, etc",
                id: "xBVNop",
              })}
            />
          )}

          <FiisEventsBox tickerSymbol={normalizedTickerSymbol} tab={tab} onChangeTab={setTab} />
        </>
      </WrapperAmplitudeCompanyTab>
    </FiisPageLayout>
  );
};

FiisEventsPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default FiisEventsPage;
